<template>
    <b-card
        :title="title"
        :loading="loading"
        :error-message="errorMessage"
        :disabled="!formValid"
        @cancel="$emit('cancel')"
        @submit="
            () => {
                mode === 'create' ? create() : update();
            }
        "
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <v-row no-gutters>
            <template v-if="mode === 'create'">
                <v-col cols="7" class="pr-2 d-flex">
                    <v-select
                        :items="activeCountries"
                        label="CC*"
                        outlined
                        v-model="user.country_id"
                        item-value="country_id"
                        no-top-margin
                        item-text="name"
                        solo
                        flat
                        dense
                        hide-details="auto"
                        color="secondary"
                        item-color="secondary"
                        class="country-code-select"
                        :success="success.countryCode"
                        :error-messages="error.countryCode"
                        @focus="error.countryCode = ''"
                        @blur="validateCountryCode"
                    >
                        <template v-slot:selection="{ item }">
                            <v-row no-gutters class="d-flex align-center">
                                <v-col class="mr-0">
                                    <img
                                        :src="item.flag"
                                        width="25"
                                        style="vertical-align: middle"
                                        class="mr-0"
                                    />
                                </v-col>

                                <v-col cols="auto">{{ item.phone_code }}</v-col>
                            </v-row>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-row no-gutters>
                                <v-col class="mr-3">
                                    <img
                                        :src="item.flag"
                                        width="25"
                                        style="vertical-align: middle"
                                        class="mr-3"
                                    />
                                    {{ item.name }} ({{ item.code }})
                                </v-col>

                                <v-col cols="auto">{{ item.phone_code }}</v-col>
                            </v-row>
                        </template>
                    </v-select>
                    <b-text-field
                        v-model="user.mobile"
                        v-mask="'############'"
                        :label="translations.mobile[lang]"
                        no-top-margin
                        :success="success.mobile"
                        :error-messages="error.mobile"
                        @focus="error.mobile = ''"
                        @blur="validateMobile"
                        class="user-mobile"
                    >
                    </b-text-field>
                </v-col>
                <v-col cols="7" class="pr-2 pt-3">
                    <b-text-field
                        v-model="user.password"
                        :type="showPassword ? 'text' : 'password'"
                        :label="translations.password[lang]"
                        no-top-margin
                        prepend-inner-icon="mdiLock"
                        append-icon="mdiEye"
                        :success="success.password"
                        :error-messages="error.password"
                        @focus="error.password = ''"
                        @blur="validatePassword"
                        @click-append="showPassword = !showPassword"
                    ></b-text-field>
                </v-col>
                <v-col cols="7" class="pr-2">
                    <b-select 
                    :items="availableRoles"
                    item-text="name"
                    item-value="role_id"
                    v-model="user.role_id"
                    :label="translations.role[lang]"
                ></b-select>
                </v-col>
            </template>
            <v-col
                cols="12"
                class="subtitle-1 text--primary py-0 mt-0"
                :class="{ 'mt-2': mode === 'create', 'mb-2': mode === 'create' }"
            >
                <v-row no-gutters align="center">
                    <v-col v-text="translations.permissions[lang]"></v-col>

                </v-row>
            </v-col>
            <b-object-treeview class="pa-5" v-model="user.permissions" />

        </v-row>
    </b-card>
</template>

<script>
import {
    mdiMenuRight,
    mdiMenuDown,
    mdiCheckboxBlankOutline,
    mdiCheckBoxOutline,
} from "@mdi/js";

import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/storePanel/settings/users/userForm";
import validators from "@/utils/validators/storePanel/user";

export default {
    name: "UserForm",

    props: {
        mode: String,
    },

    mixins: [translations, validators],

    data() {
        return {
            icons: {
                mdiMenuRight,
                mdiMenuDown,
                mdiCheckboxBlankOutline,
                mdiCheckBoxOutline,
            },
            showPassword: false,
            allPermissions: false,
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "resetSuccess",
            "resetValidation",
            "activeCountries",
            "store"
        ]),
        ...mapState("storePanel/settings/users", ["moderatorPermissions", "user", "roles"]),

        lang() {
            return this.$route.params.lang;
        },

        title() {
            return this.mode === 'create'
                ? this.translations.newUser[this.lang]
                : this.translations.updateUser[this.lang];
        },
        availableRoles() {
            return this.roles.filter(role => role.system.match(/store_/i))
        }
    },

    methods: {
        ...mapMutations(["setResetSuccess", "setResetValidation"]),
        ...mapActions(["loadActiveCountries"]),
        ...mapActions("storePanel/settings/users", ["create", "update", "getRoles"]),
    },

    mounted() {
        this.getRoles()
        if(!this.activeCountries?.length) {
           this.loadActiveCountries()
        }
        if (!this.user.country_id) {
            this.user.country_id = this.store?.country?.country_id;
        }
    },
    watch: {
        ['user.user_id'](val) {
            if (!val && this.store?.country?.country_id) {
                val = this.store?.country?.country_id;
            }
        }
    },

};
</script>


<style lang="scss">
.country-code-select .v-input__slot {
    min-width: 110px;
    padding: 0 4px 0 8px !important;
}
.country-code-select .v-select__selections input {
    padding: 0 !important;
    margin: 0 !important;
    height: 0 !important;
    width: 0 !important;
    overflow: hidden !important;
}

.country-code-select .v-input__append-inner {
    padding-left: 0 !important;
}

.country-code-select .v-input__append-inner .v-icon.v-icon::after {
    max-width: 20px;
    min-width: 20px;
}

.country-code-select fieldset {
    border-right: 1px dotted black !important;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}
.user-mobile fieldset {
    border-left: none !important;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}
</style>
